export var meta = {
  name: 'Node Demo',
  pathSegment: 'node-demo'
};
export var getMenu = function getMenu(access) {
  return [{
    text: 'Node Demo',
    pathSegment: '/'
  }];
};
export var config = {};
export { default } from "./App.js";